import { render, staticRenderFns } from "./UpdateModal.vue?vue&type=template&id=c1ad8018&scoped=true&"
import script from "./UpdateModal.vue?vue&type=script&lang=js&"
export * from "./UpdateModal.vue?vue&type=script&lang=js&"
import style0 from "./UpdateModal.vue?vue&type=style&index=0&id=c1ad8018&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1ad8018",
  null
  
)

export default component.exports